// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__jdrwb","title":"styles_title__1__kx","label":"styles_label__L5iah","skeleton-animation":"styles_skeleton-animation___yvdj"};